<template>
  <div>
    <main class="site-content">
      <section class="hero is-danger">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              IceTiger.eu
            </h1>
            <h2 class="subtitle" style="margin-top: 0.5vh;">
              Home of the German IceTiger
            </h2>
            <!-- Internet Explorer User may encounter some problems -->
            <div v-if="isIE" class="notification is-danger">
              <div class="has-text-centered">This site is not optimized for Internet Explorer and may not work like expected!</div>
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="container">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">Next Event</p>
              <a :href="event.url" :title="event.name + ' - ' + event.provider.name" class="card-header-icon" aria-label="event url">
                <span class="icon"><i class="fas fa-external-link-alt" aria-hidden="true"></i></span>
              </a>
            </header>
            <div class="card-content">
              <div class="content">
                <p class="title is-4"><a :href="event.url">{{ event.name }}</a></p>
                <p class="subtitle is-6">{{ event.subtitle }}</p>
                <p>
                  Date: <b>{{ event.from }}</b> - <b> {{ event.to }}</b><br />
                  Location: {{ event.location }}<br />
                  Don't want to miss this adventure?*<br />
                  <template v-if="event.regStart !== undefined">Registration starts at {{ event.regStart }}.<br /></template>
                </p>
                <p class="is-size-7">* This service is offered by the <a :href="event.provider.homepageUrl">{{ event.provider.name }}</a></p>
              </div>
              <div class="has-text-centered">
                <Countdown deadline="September 18, 2024 00:00:01"></Countdown>
              </div>
            </div>
            <footer class="card-footer">
              <a :href="event.regUrl" class="card-footer-item">Register</a>
              <a :href="event.provider.footTwitterUrl" class="card-footer-item">{{event.provider.name}} on Twitter</a>
            </footer>
          </div>
        </div>
      </section>
    </main>reading samplean IceTiger" description="Home of IceTiger, a German Furry." keywords="icetiger, furry" url="https://icetiger.eu/"></vue-headful>
  </div>
</template>

<script>
import Countdown from 'vuejs-countdown'

export default {
  name: 'Index',
  data () {
    return {
      isIE: /Trident\/|MSIE/.test(window.navigator.userAgent),
      event: {
        "name": "Eurofurence 28",
        "subtitle": "Cyberpunk",
        "url": "https://www.eurofurence.org/EF28/",
        "from": "2024-09-18",
        "to": "2024-09-21",
        "location": "CCH Hamburg, Germany",
        "provider": {
          "name": "Eurofurence e.V.",
          "homepageUrl": "https://eurofurence.de/",
          "footTwitterUrl": "https://twitter.com/eurofurence"
        },
        "regUrl": "https://identity.eurofurence.org/",
        "regStart": undefined
      }
    }
  },
  components: { Countdown }
}
</script>
<style src="@/assets/main.css"></style>



// WEBPACK FOOTER //
// src/components/Index.vue